module.exports = __webpack_public_path__ + "static/media/Gilderoy-Lockheart.e38406ba.png";